export const restrictionConfig = {
  isApplicationPaused: false,
  popupTitle: "Temporarily Unavailable",
  popupMessage: `Dear {userName},

Applications for Life Membership, Membership Renewal, IOTR Certificate, and Good Standing Certificate are temporarily unavailable due to ongoing updates in the application format and process.

We request you to kindly revisit after 6th May 2026.

We appreciate your understanding.`,
  buttonText: "OK"
};
